import { sprintf } from "../utils/fns";
export class OptimizelyError extends Error {
    constructor(baseMessage, ...params) {
        super();
        this.resolved = false;
        this.name = 'OptimizelyError';
        this.baseMessage = baseMessage;
        this.params = params;
        // this is needed cause instanceof doesn't work for
        // custom Errors when TS is compiled to es5
        Object.setPrototypeOf(this, OptimizelyError.prototype);
    }
    setMessage(resolver) {
        if (!this.resolved) {
            this.message = sprintf(resolver.resolve(this.baseMessage), ...this.params);
            this.resolved = true;
        }
    }
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=optimizly_error.js.map